import React, {useEffect, useState} from 'react';
import useAmplifyAuth from "../../../helpers/useAmplifyAuth";
import {useParams, Link, useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {hideLoading} from "../../../reducers/app";
import './ConfirmRegistration.scss'
import Modal from "../../common/Modal/Modal";


const ConfirmRegistration = () => {

  const [error, setError] = useState(false)
  const {t} = useTranslation();

  let {username, code} = useParams();
  const {confirmSignup} = useAmplifyAuth();
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    confirmSignup(username, code)
      .then((data) => {
        if (data) {
          window.dataLayer.push({"event": "registrazioneDoubleOptIn"});
          dispatch(hideLoading());
          return history.push("/login")
        }
      })
      .catch((error) => {
        console.log("[ERROR] ", error);
        setError(true)
        dispatch(hideLoading());
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const errorConfirm = () => {
    return (
      <Modal
        show={error}
        onClose={() => history.push("/login")}
        icon={"gc-icon-functional-attention-2-col"}
        description={t('confirm.registration.text')}
        type={"link"}
        linkTitle={t("confirm.registration.button")}
        to={"/login"}
      />
    )
  };

  return (
    <div className="ConfirmRegistration" data-testid="ConfirmRegistration">
      {error && errorConfirm()}
    </div>
  )
}


export default ConfirmRegistration;
